import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p className="footer-text">© 2026 Tejeesh Sai Reddi. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;